import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
    HostBinding,
    inject,
    input,
    signal
} from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Store } from '@ngxs/store';
import { ZFloatLabelNumberComponent } from '@shared/components/form-components/z-float-label-number/z-float-label-number.component';
import { ZFloatLabelComponent } from '@shared/components/form-components/z-float-label/z-float-label.component';
import { ZionMessagesService } from '@shared/services/ax-messages.service';
import { LoaderService } from '@shared/services/loader.service';
import { EntityFormModeType } from '@shared/types/entity-form-mode.type';
import {
    AddressTypeFormGroupSelector,
    AddressTypeQuery,
    InvoiceIssuerGraphQLSchemaActions,
    InvoiceIssuerGraphQLSchemaSelectors,
    InvoiceIssuerType,
    InvoiceIssuerTypeFormGroup,
    InvoiceIssuerTypeFormGroupSelector,
    InvoiceIssuerTypeQuery
} from '@shared/zigra-schemas/zigra-schema.autogenerated.models';
import { ToastMessageOptions } from 'primeng/api';
import { Button, ButtonModule } from 'primeng/button';
import { DynamicDialogConfig } from 'primeng/dynamicdialog';
import { FloatLabel } from 'primeng/floatlabel';
import { finalize } from 'rxjs';
import { ObjectId, QueryFilterGroup } from 'zigra-ng-framework';
import { ZPosTerminalsSelectComponent } from '../../pos-terminals/z-pos-terminals-select/z-pos-terminals-select.component';

@Component({
    selector: 'zion-z-invoice-issuer-edit',
    imports: [
        FormsModule,
        ReactiveFormsModule,
        ZFloatLabelComponent,
        ButtonModule
    ],
    templateUrl: './z-invoice-issuer-edit.component.html',
    styleUrl: './z-invoice-issuer-edit.component.scss'
    // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ZInvoiceIssuerEditComponent {
    @HostBinding('style') style = 'height: 100%';

    productDialogMode = input<EntityFormModeType | undefined>(undefined);
    invoiceIssuerId = input<ObjectId | undefined>(undefined);
    invoiceIssuer = signal<InvoiceIssuerType | undefined>(undefined);
    invoiceIssuers = signal<InvoiceIssuerType[] | undefined>(undefined);
    selectedInvoiceIssuerId?: ObjectId;

    protected store = inject(Store);
    protected cd = inject(ChangeDetectorRef);
    protected loaderService = inject(LoaderService);
    protected messageService = inject(ZionMessagesService);
    protected formGroup?: InvoiceIssuerTypeFormGroup;
    protected dialogConfig: DynamicDialogConfig<IInvoiceIssuerEditOptions> =
        inject(DynamicDialogConfig<IInvoiceIssuerEditOptions>);

    ngOnInit(): void {
        // this.productDepartment()?.Code;
        // this.productDepartment()?.Title;
        // this.productDepartment()?.Description;
        // this.productDepartment()?.ParentId;
        //this.productDepartment()?.VATCategoryId;

        //this.productPackage()?.InvoicingList?.[0]?.VATCategoryId

        const groupQuery = {
            GroupQuery: QueryFilterGroup.JoinWithOrOperator([
                QueryFilterGroup.FieldIsEqualToObjectId<InvoiceIssuerType>(
                    ['_id'],
                    this.invoiceIssuerId() ?? '000000000000000000000000'
                )
            ])
        };

        // if (this.posTerminalId() == undefined)
        //     this.posTerminal.set({
        //         Code: undefined,
        //         Title: undefined,
        //         Description: undefined
        //     } as POSTerminalType);
        // else
        this.store
            .dispatch(
                new InvoiceIssuerGraphQLSchemaActions.Fetch(
                    queryForEdit,
                    undefined //groupQuery
                )
            )
            .subscribe(() => {
                const userAPIInfos = this.store.selectSnapshot(
                    InvoiceIssuerGraphQLSchemaSelectors.FetchSelector('', '')
                )?.data?.Fetch;

                this.invoiceIssuers.set(userAPIInfos);

                // const posTerminals =
                //     this.store.selectSnapshot(
                //         POSTerminalGraphQLSchemaSelectors.FetchSelector('', '')
                //     )?.data?.Fetch ?? [];

                this.invoiceIssuer.set(this.invoiceIssuers()?.[0]);
                this.selectedInvoiceIssuerId = this.invoiceIssuer()?._id;
                debugger;

                this.formGroup = new InvoiceIssuerTypeFormGroup(
                    this.invoiceIssuer(),
                    formForEditSelector
                );

                // debugger;
                // this.formGroup.clearValidators();
                // this.formGroup.controls.Parent?.patchValue(undefined as any);

                // this.formGroup.controls.Code?.addValidators([Validators.required]);
                // this.formGroup.controls.Code?.updateValueAndValidity();
                // this.formGroup.controls.Title?.addValidators([Validators.required]);
                // this.formGroup.controls.Title?.updateValueAndValidity();
                // this.formGroup.controls.Description?.addValidators(Validators.required);
                // this.formGroup.controls.Description?.updateValueAndValidity();
                // this.formGroup.controls.VATCategoryId?.addValidators(
                //     Validators.required
                // );
                // this.formGroup.controls.VATCategoryId?.updateValueAndValidity();

                // this.formGroup?.updateValueAndValidity();
                // this.formGroup?.markAllAsTouched();

                if (this.dialogConfig.data)
                    this.dialogConfig.data.invoiceIssuerTypeFormGroup =
                        this.formGroup;

                //this.cd.detectChanges();
            });
    }

    // onSelectPOSTerminal(posTerminalId: ObjectId) {
    //     this.userAPIInfo.set(
    //         this.userAPIInfos()?.find(
    //             (posTerminal) => posTerminal._id == posTerminalId
    //         )
    //     );
    // }

    saveInvoiceIssuer() {
        const userAPIInfo = this.formGroup?.value as InvoiceIssuerType;
        this.loaderService.showAwaitDataSaveLoader();
        this.store
            .dispatch(
                new InvoiceIssuerGraphQLSchemaActions.Upsert(
                    userAPIInfo,
                    undefined,
                    InvoiceIssuerTypeQuery.GQLQuery()
                )
            )
            .pipe(finalize(() => this.loaderService.dismissAwaitLoader()))
            .subscribe(() => {
                this.messageService.add({
                    summary: 'Καταχώρηση Στοιχείων Εκδότη',
                    detail: 'Η Καταχώρηση ολοκληρώθηκε επιτυχώς',
                    severity: 'success',
                    key: 'br'
                } as ToastMessageOptions);

                this.dialogConfig.data?.onSave(this.dialogConfig.data);
            });
    }
}

const queryForEdit = InvoiceIssuerTypeQuery.GQLQuery({
    Address: AddressTypeQuery.GQLQuery()
});

const formForEditSelector = new InvoiceIssuerTypeFormGroupSelector({
    ...InvoiceIssuerTypeFormGroupSelector.Selector(),
    Address: AddressTypeFormGroupSelector.Selector()
});

export interface IInvoiceIssuerEditOptions {
    mode: 'new' | 'edit' | 'view' | 'delete';
    //dclId?: number;
    //digitalClientCardType: DigitalClientCardType;
    invoiceIssuerTypeFormGroup?: InvoiceIssuerTypeFormGroup;

    onSave: (options: IInvoiceIssuerEditOptions) => void;
}
